const TagEditorClassNames = Object.freeze({
  REMOVE_TAG: 'js-remove-tag',
  AUTOCOMPLETE_INPUT: 'js-autocomplete__input',
  ADD_TAG_BUTTON: 'js-add-tag-button',
  ADD_TAG_LABEL: 'js-add-tag-label',
  TAG_OPTION: 'js-tag-option'
});

export default TagEditorClassNames;
